/**
 * THE FIRM — the decisions that are the firm's, not one engagement's.
 * Today: how its documents are read (ADR-0020).
 */
import { Desk } from "./shell.js";
import { Label, SERIF_OPSZ } from "../file/index.js";
import { DocumentReadingSection } from "./documentReading.js";

export function FirmScreen() {
  return (
    <Desk current="firm">
      <Label>Leveri</Label>
      <h1 className="mt-2 font-serif text-[32px] font-medium leading-[1.15] tracking-[-0.015em] text-ink" style={SERIF_OPSZ}>Your firm</h1>
      <div className="mt-6"><DocumentReadingSection /></div>
    </Desk>
  );
}
